import type { CompanyOption } from '@/hooks/useAvailableCompanies'

interface CompanySelectProps {
  id: string
  options: CompanyOption[]
  value: number | null
  onChange: (companyId: number | null) => void
  className: string
  /** Rótulo da opção "nenhuma em particular" (valor `null`). Sem ele, a
   * empresa é obrigatória. */
  allLabel?: string
}

/** Select de empresa dos formulários de criação (Atendimento HUB e "Nova
 * ocorrência"). */
export function CompanySelect({
  id,
  options,
  value,
  onChange,
  className,
  allLabel,
}: CompanySelectProps) {
  return (
    <select
      id={id}
      value={value ?? ''}
      onChange={(e) =>
        onChange(e.target.value === '' ? null : Number(e.target.value))
      }
      className={className}
    >
      {allLabel && <option value="">{allLabel}</option>}
      {options.map((c) => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>
  )
}
